import React from 'react';
import styles from './PrivacyPolicy.module.css';

const PrivacyPolicy = () => {
  return (
    <div className={styles.privacyContainer}>
      <h1>Privacy Policy</h1>

      <p className={styles.effectiveDate}>
        Effective Date: Baisakh 1, 2081 (April 14, 2024 AD)
      </p>

      {/* ===================================================== */}
      {/* 1. INFORMATION WE COLLECT */}
      {/* ===================================================== */}
      <section className={styles.privacySection}>
        <h2 className={styles.privacyHeading}>
          1. Information We Collect
        </h2>

        <p className={styles.privacyText}>
          YetiDeals collects certain information to provide and improve our
          ecommerce services in accordance with applicable laws of Nepal.
        </p>

        <ul className={styles.privacyList}>
          <li className={styles.privacyListItem}>
            <strong>Personal Information:</strong> Full name, email address,
            phone number, delivery address
          </li>

          <li className={styles.privacyListItem}>
            <strong>Account Information:</strong> Username, encrypted password,
            profile preferences
          </li>

          <li className={styles.privacyListItem}>
            <strong>Transaction Data:</strong> Order history, delivery status,
            return records, COD details
          </li>

          <li className={styles.privacyListItem}>
            <strong>Device Information:</strong> IP address, browser type,
            device information, operating system
          </li>

          <li className={styles.privacyListItem}>
            <strong>Communication Data:</strong> Customer support messages,
            emails, chats, and communications provided by you
          </li>
        </ul>

        <p className={styles.privacyText}>
          We collect information when you:
        </p>

        <ul className={styles.privacyList}>
          <li className={styles.privacyListItem}>
            Create an account on YetiDeals
          </li>

          <li className={styles.privacyListItem}>
            Place an order on our platform
          </li>

          <li className={styles.privacyListItem}>
            Submit returns, warranty, or support requests
          </li>

          <li className={styles.privacyListItem}>
            Subscribe to newsletters or promotional offers
          </li>

          <li className={styles.privacyListItem}>
            Contact customer support
          </li>
        </ul>
      </section>

      {/* ===================================================== */}
      {/* 2. HOW WE USE INFORMATION */}
      {/* ===================================================== */}
      <section className={styles.privacySection}>
        <h2 className={styles.privacyHeading}>
          2. How We Use Your Information
        </h2>

        <p className={styles.privacyText}>
          We use your information for the following purposes:
        </p>

        <ul className={styles.privacyList}>
          <li className={styles.privacyListItem}>
            Processing and delivering orders
          </li>

          <li className={styles.privacyListItem}>
            Communicating order updates and support responses
          </li>

          <li className={styles.privacyListItem}>
            Processing returns, refunds, and warranty claims
          </li>

          <li className={styles.privacyListItem}>
            Improving platform functionality and user experience
          </li>

          <li className={styles.privacyListItem}>
            Preventing fraud, fake orders, abuse, and unauthorized activities
          </li>

          <li className={styles.privacyListItem}>
            Maintaining platform security and operational integrity
          </li>

          <li className={styles.privacyListItem}>
            Complying with applicable laws and legal obligations in Nepal
          </li>
        </ul>
      </section>

      {/* ===================================================== */}
      {/* 3. INFORMATION SHARING */}
      {/* ===================================================== */}
      <section className={styles.privacySection}>
        <h2 className={styles.privacyHeading}>
          3. Information Sharing & Disclosure
        </h2>

        <p className={styles.privacyText}>
          YetiDeals does not sell or rent your personal information to third
          parties.
        </p>

        <p className={styles.privacyText}>
          We may share limited information only when necessary:
        </p>

        <ul className={styles.privacyList}>
          <li className={styles.privacyListItem}>
            <strong>Delivery Partners:</strong> Name, phone number, and address
            required for delivery fulfillment
          </li>

          <li className={styles.privacyListItem}>
            <strong>Vendors/Sellers:</strong> Order-related information required
            for preparing and processing orders
          </li>

          <li className={styles.privacyListItem}>
            <strong>Legal Authorities:</strong> When required under applicable
            laws of Nepal
          </li>

          <li className={styles.privacyListItem}>
            <strong>Fraud Prevention:</strong> To investigate suspicious,
            fraudulent, or illegal activities
          </li>
        </ul>

        <p className={styles.privacyText}>
          We take reasonable measures to ensure third parties protect your data
          responsibly.
        </p>
      </section>

      {/* ===================================================== */}
      {/* 4. COOKIES */}
      {/* ===================================================== */}
      <section className={styles.privacySection}>
        <h2 className={styles.privacyHeading}>
          4. Cookies & Tracking Technologies
        </h2>

        <p className={styles.privacyText}>
          YetiDeals uses cookies and related technologies to:
        </p>

        <ul className={styles.privacyList}>
          <li className={styles.privacyListItem}>
            Maintain login sessions
          </li>

          <li className={styles.privacyListItem}>
            Remember cart and browsing preferences
          </li>

          <li className={styles.privacyListItem}>
            Improve website performance and analytics
          </li>

          <li className={styles.privacyListItem}>
            Personalize user experience
          </li>
        </ul>

        <p className={styles.privacyText}>
          You may disable cookies through your browser settings, although some
          features of the platform may not function properly.
        </p>
      </section>

      {/* ===================================================== */}
      {/* 5. DATA SECURITY */}
      {/* ===================================================== */}
      <section className={styles.privacySection}>
        <h2 className={styles.privacyHeading}>
          5. Data Security Measures
        </h2>

        <p className={styles.privacyText}>
          We implement reasonable and industry-standard security measures to
          protect your information.
        </p>

        <ul className={styles.privacyList}>
          <li className={styles.privacyListItem}>
            SSL/TLS encrypted connections
          </li>

          <li className={styles.privacyListItem}>
            Secure password protection and encryption
          </li>

          <li className={styles.privacyListItem}>
            Restricted access to sensitive information
          </li>

          <li className={styles.privacyListItem}>
            Regular security monitoring and maintenance
          </li>

          <li className={styles.privacyListItem}>
            Secure server and infrastructure protection
          </li>
        </ul>

        <p className={styles.privacyText}>
          While we strive to protect your data, no online platform or method of
          electronic transmission can guarantee absolute security.
        </p>
      </section>

      {/* ===================================================== */}
      {/* 6. USER RIGHTS */}
      {/* ===================================================== */}
      <section className={styles.privacySection}>
        <h2 className={styles.privacyHeading}>
          6. Your Rights
        </h2>

        <p className={styles.privacyText}>
          Subject to applicable laws, you may have the right to:
        </p>

        <ul className={styles.privacyList}>
          <li className={styles.privacyListItem}>
            Request access to your personal information
          </li>

          <li className={styles.privacyListItem}>
            Correct inaccurate or outdated information
          </li>

          <li className={styles.privacyListItem}>
            Request deletion of your account and personal data
          </li>

          <li className={styles.privacyListItem}>
            Opt out of promotional communications
          </li>
        </ul>

        <p className={styles.privacyText}>
          To make a request, contact us using the information provided below.
        </p>
      </section>

      {/* ===================================================== */}
      {/* 7. DATA RETENTION */}
      {/* ===================================================== */}
      <section className={styles.privacySection}>
        <h2 className={styles.privacyHeading}>
          7. Data Retention Policy
        </h2>

        <p className={styles.privacyText}>
          We retain personal information only for as long as reasonably
          necessary for operational, legal, and security purposes.
        </p>

        <ul className={styles.privacyList}>
          <li className={styles.privacyListItem}>
            Active account information while your account remains active
          </li>

          <li className={styles.privacyListItem}>
            Transaction records for accounting, auditing, and legal purposes
          </li>

          <li className={styles.privacyListItem}>
            Support communications for service quality and dispute resolution
          </li>
        </ul>

        <p className={styles.privacyText}>
          Data may be securely deleted or anonymized after retention periods
          expire.
        </p>
      </section>

      {/* ===================================================== */}
      {/* 8. CHILDREN */}
      {/* ===================================================== */}
      <section className={styles.privacySection}>
        <h2 className={styles.privacyHeading}>
          8. Children’s Privacy
        </h2>

        <p className={styles.privacyText}>
          YetiDeals is not intended for children without appropriate supervision
          or consent where required by applicable laws.
        </p>

        <p className={styles.privacyText}>
          If we become aware that personal information has been improperly
          collected from a child, we may take reasonable steps to delete such
          information.
        </p>
      </section>

      {/* ===================================================== */}
      {/* 9. ORDER VERIFICATION */}
      {/* ===================================================== */}
      <section className={styles.privacySection}>
        <h2 className={styles.privacyHeading}>
          9. Order Verification & Fraud Prevention
        </h2>

        <p className={styles.privacyText}>
          To prevent fraud and maintain platform security, YetiDeals may request
          additional verification for suspicious or unusually high-value orders.
        </p>

        <ul className={styles.privacyList}>
          <li className={styles.privacyListItem}>
            Verification may include phone confirmation or identity documents
          </li>

          <li className={styles.privacyListItem}>
            Verification information is used only for security and fraud
            prevention purposes
          </li>

          <li className={styles.privacyListItem}>
            Failure to complete verification may result in order cancellation
          </li>
        </ul>
      </section>

      {/* ===================================================== */}
      {/* 10. THIRD PARTY LINKS */}
      {/* ===================================================== */}
      <section className={styles.privacySection}>
        <h2 className={styles.privacyHeading}>
          10. Third-Party Links
        </h2>

        <p className={styles.privacyText}>
          Our platform may contain links to third-party websites or services.
          YetiDeals is not responsible for the privacy practices or content of
          external websites.
        </p>

        <p className={styles.privacyText}>
          We encourage users to review third-party privacy policies before
          providing personal information.
        </p>
      </section>

      {/* ===================================================== */}
      {/* 11. BREACH NOTIFICATION */}
      {/* ===================================================== */}
      <section className={styles.privacySection}>
        <h2 className={styles.privacyHeading}>
          11. Security Incidents & Notifications
        </h2>

        <p className={styles.privacyText}>
          In the event of a significant security incident affecting personal
          information, we will make reasonable efforts to investigate, mitigate,
          and notify affected users when appropriate.
        </p>
      </section>

      {/* ===================================================== */}
      {/* 12. POLICY CHANGES */}
      {/* ===================================================== */}
      <section className={styles.privacySection}>
        <h2 className={styles.privacyHeading}>
          12. Changes to This Policy
        </h2>

        <p className={styles.privacyText}>
          YetiDeals may update this Privacy Policy periodically to reflect
          operational, legal, or service-related changes.
        </p>

        <p className={styles.privacyText}>
          Updated versions will be published on this page with a revised
          effective date.
        </p>

        <p className={styles.privacyText}>
          Continued use of the platform after changes become effective
          constitutes acceptance of the updated policy.
        </p>
      </section>

      {/* ===================================================== */}
      {/* 13. GOVERNING LAW */}
      {/* ===================================================== */}
      <section className={styles.privacySection}>
        <h2 className={styles.privacyHeading}>
          13. Governing Law & Jurisdiction
        </h2>

        <p className={styles.privacyText}>
          This Privacy Policy shall be governed by the applicable laws of Nepal.
        </p>

        <p className={styles.privacyText}>
          Any disputes related to this policy shall be subject to the applicable
          courts of Nepal, with preference to courts located in Jhapa District.
        </p>
      </section>

      {/* ===================================================== */}
      {/* 14. CONTACT */}
      {/* ===================================================== */}
      <section className={styles.privacySection}>
        <h2 className={styles.privacyHeading}>
          14. Contact Information
        </h2>

        <p className={styles.privacyText}>
          If you have questions, concerns, or requests regarding this Privacy
          Policy, please contact:
        </p>

        <p className={styles.privacyText}>
          <strong>YetiDeals Support & Grievance Team</strong>
          <br />
          <strong>Email:</strong> yetideals.np@gmail.com
          <br />
          <strong>Phone:</strong> +977-9815014878
          <br />
          <strong>Address:</strong> Birtamode-4, Jhapa, Nepal
        </p>

        <p className={styles.privacyText}>
          We will make reasonable efforts to respond to your inquiry promptly.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
